/**
 * Gap above a widget on campaign variants B and C — 8px.
 *
 * Answers item 2 of the V1 acceptance Mängelliste (SH-415), which reported the
 * hero sitting flush against what follows it. Variant A is unchanged, so the
 * class is applied by the B/C wrapper components rather than by the shared
 * component they wrap.
 *
 * Shared rather than declared per widget so the variants cannot drift apart as
 * more of them adopt it. Currently used by the Ticker and by Location Features
 * ("Standortmerkmale").
 *
 * NB it carries no breakpoint prefix, so it applies at every width. That suits
 * a widget in normal flow, such as Location Features. A widget that is *not*
 * in flow needs {@link CAMPAIGN_VARIANT_TOP_SPACING_IN_FLOW_ONLY} instead —
 * a margin still offsets a fixed-position box, so applying this to one shifts
 * it away from its anchor.
 */
export const CAMPAIGN_VARIANT_TOP_SPACING = 'mt-2';

/**
 * The same 8px gap, suppressed below `lg`.
 *
 * For the Ticker, which is `max-lg:fixed … top-0` below `lg`: pinned to the
 * viewport and out of normal flow. A margin is *not* ignored there — it offsets
 * the box from its `top` anchor — so the plain class would push the banner 8px
 * down the viewport, opening a gap above it and pushing it 8px past the
 * `body { padding-top: var(--ticker-height) }` offset that reserves its space
 * in `globals.css`. From `lg` up the Ticker is in flow and takes the margin
 * normally.
 */
export const CAMPAIGN_VARIANT_TOP_SPACING_IN_FLOW_ONLY = 'mt-2 max-lg:mt-0';
